import React, { useState, useEffect } from 'react';
import { clubsApi } from '../lib/api';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { Shield, Users, Crown, Star } from 'lucide-react';

const ClubRosterDialog = ({ clubId, clubName, clubLogo, onClose }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) return;
    setLoading(true);
    clubsApi.getMembers(clubId)
      .then(res => setMembers(res.data || []))
      .catch(() => setMembers([]))
      .finally(() => setLoading(false));
  }, [clubId]);

  return (
    <Dialog open={!!clubId} onOpenChange={() => onClose()}>
      <DialogContent className="bg-[#0a0d15] border-white/10 text-white max-w-sm max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3">
            {clubLogo ? (
              <img src={clubLogo} alt="" className="w-8 h-8 object-cover rounded" />
            ) : (
              <Shield size={24} className="text-[#00F0FF]" />
            )}
            <span className="font-heading text-lg uppercase tracking-wider truncate">{clubName || 'Roster'}</span>
          </DialogTitle>
        </DialogHeader>
        <div className="mt-2">
          {loading ? (
            <div className="flex justify-center py-8">
              <div className="animate-spin w-6 h-6 border-2 border-[#00F0FF] border-t-transparent rounded-full" />
            </div>
          ) : members.length > 0 ? (
            <div className="space-y-1" data-testid="roster-list">
              {members.map((m) => {
                const isCaptain = m.is_captain || m.role === 'captain';
                const isVice = m.is_vice_captain;
                return (
                  <div
                    key={m.user_id}
                    className="flex items-center gap-3 px-3 py-2 rounded bg-[#050508] border border-white/5 hover:border-white/15 transition-colors"
                    data-testid={`roster-player-${m.user_id}`}
                  >
                    <div className="w-8 h-8 rounded-full bg-[#0a0d15] border border-white/10 flex items-center justify-center flex-shrink-0 overflow-hidden">
                      {m.picture || m.avatar ? (
                        <img src={m.picture || m.avatar} alt="" className="w-full h-full object-cover" />
                      ) : (
                        <Users size={14} className="text-slate-600" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium text-white truncate">{m.gamertag || m.name}</p>
                      {(isCaptain || isVice) && (
                        <p className="text-[10px] text-[#FFEA00] uppercase tracking-wider flex items-center gap-1">
                          {isCaptain ? <><Crown size={9} /> Capitano</> : <><Star size={9} /> Vice Capitano</>}
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-8 text-slate-500 text-sm">
              Nessun giocatore nel roster
            </div>
          )}
          <p className="text-[10px] text-slate-600 text-center mt-3">
            {members.length} {members.length === 1 ? 'giocatore' : 'giocatori'}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ClubRosterDialog;
